"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_final_form_1 = require("react-final-form");
const index_1 = require("../../components/index");
const ToggleField = ({ name, label, validate }) => (react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate }, ({ input }) => (react_1.default.createElement(index_1.FormControlLabel, { label: label, control: react_1.default.createElement(index_1.Switch, { checked: input.value, 
        // @ts-ignore
        onChange: (_event, checked) => {
            input.onChange(checked);
        } }) }))));
exports.default = ToggleField;
